"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var core_utilities_1 = require("@syl-editor/core-utilities");
var createTemplElement = function () {
    var templ = document.createElement('templ');
    templ.setAttribute('style', 'display:none');
    return templ;
};
var LayerRenderer = /** @class */ (function () {
    function LayerRenderer(adapter, container, ViewMap, Renderer, name) {
        var _this = this;
        this.viewMap = {};
        this.layerType = 'template';
        this.curProps = {};
        this.iteratorViewMap = function (cb) {
            Object.keys(_this.viewMap).forEach(function (name) {
                cb(_this.viewMap[name]);
            });
        };
        this.updateTemplate = function (layerType) {
            if (layerType === void 0) { layerType = 'template'; }
            if (!_this.ViewMap[layerType] || layerType === _this.layerType)
                return;
            _this.viewMap.template.unmount();
            _this.layerType = layerType;
            _this.viewMap.template = new _this.Renderer(_this.adapter, _this.ViewMap[layerType], _this.templateRoot, _this.name);
            _this.viewMap.template.setProps(_this.curProps, core_utilities_1.Types.noop);
        };
        /**
         * update view if props changed, will update all of cached viewMap
         * at the same time
         */
        this.update = function (props) {
            _this.curProps = props;
            _this.iteratorViewMap(function (renderer) {
                renderer.setProps(props, core_utilities_1.Types.noop);
            });
        };
        this.container = container;
        this.ViewMap = ViewMap;
        this.adapter = adapter;
        this.Renderer = Renderer;
        this.name = name;
        this.templateRoot = createTemplElement();
        this.viewMap.template = new Renderer(this.adapter, this.ViewMap.template, this.templateRoot, this.name);
        if (!this.ViewMap.mask)
            this.ViewMap.mask = this.ViewMap.template;
        var maskRoot = document.createElement('mask');
        this.viewMap.mask = new Renderer(this.adapter, this.ViewMap.mask, maskRoot, this.name);
        adapter.on(core_utilities_1.EventChannel.LocalEvent.SWITCH_LAYER, this.updateTemplate);
    }
    LayerRenderer.prototype.renderLayer = function () {
        var _this = this;
        this.iteratorViewMap(function (renderer) {
            return _this.container.appendChild(renderer.container);
        });
    };
    /**
     * mount card in dom container
     * @param props
     */
    LayerRenderer.prototype.mount = function (props) {
        // be sure container dom is clean
        var childNodes = Array.from(this.container.childNodes);
        for (var _i = 0, childNodes_1 = childNodes; _i < childNodes_1.length; _i++) {
            var child = childNodes_1[_i];
            child.remove();
        }
        this.update(props);
        this.renderLayer();
    };
    /**
     * uninstall all of the Render View
     */
    LayerRenderer.prototype.uninstall = function () {
        this.iteratorViewMap(function (renderer) {
            renderer.unmount();
        });
        this.adapter.off(core_utilities_1.EventChannel.LocalEvent.SELECTION_CHANGED, this.updateTemplate);
        this.adapter.off(core_utilities_1.EventChannel.LocalEvent.SWITCH_LAYER, this.updateTemplate);
    };
    return LayerRenderer;
}());
exports.LayerRenderer = LayerRenderer;
//# sourceMappingURL=layer-renderer.js.map